import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Popover } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import TextField from 'common/forms/TextField';
import { SortKey } from 'enums/common.enum';
import { Form } from 'react-final-form';
import { validateMinLength } from 'common/forms/formValidations';
import { updateUnReconciledOrdersFilter } from 'store/thunks/workQueueThunks';
import { workQueueActions } from 'store/slices/workQueueSlice';

const ReconcileShipmentFilterButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue: { reconcileShipment } }) => reconcileShipment.filter);
  const loading = useSelector((state) => state.workQueue.reconcileShipment.loading);

  const handleClose = () => setAnchorEl(null);
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const popoverId = anchorEl ? 'WorkQueue-ReconcileShipmentFilterButton-Popover' : undefined;

  const handleApplyFilter = (formData) => {
    dispatch(workQueueActions.clearSelectedIrreconcileOrders());
    dispatch(workQueueActions.setReconcileSearchInput(''));
    dispatch(workQueueActions.setFilteredData([]));
    setAnchorEl(null);

    dispatch(
      updateUnReconciledOrdersFilter({
        filter: {
          ...formData,
        },
      })
    );
  };
  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Name'
                      name={SortKey.PATIENT_NAME}
                      id='WorkQueue-ReconcileShipmentFilterButton-patientName-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Order Number'
                      name={SortKey.ORDER_NUMBER}
                      id='WorkQueue-ReconcileShipmentFilterButton-orderNumber-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label=' Order Id'
                      name={SortKey.SP_ORDER_ID}
                      id='WorkQueue-ReconcileShipmentFilterButton-spOrderId-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Tracking Number'
                      name={SortKey.TRACKING_NUMBER}
                      id='WorkQueue-ReconcileShipmentFilterButton-trackingNumber-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <LoadingButton
                      loading={loading}
                      type='submit'
                      variant='contained'
                      disabled={invalid}
                    >
                      Apply
                    </LoadingButton>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default ReconcileShipmentFilterButton;
